/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect, useState } from "react";
import { SimpliCitySDK } from "cms/sdk";
import { useAuth } from "cms/auth/hooks/useAuth";
import { isValidGuid } from "../utils/empty-exists";

const  useSimWebpageImage = (webpage_guid) => {

    const { token } = useAuth();

    const [image,setImage] = useState();
    const [settings,setSettings] = useState();
    const [inProgress,setInProgress] = useState(false);
    const [loaded,setLoaded] = useState(false);

    useEffect(() => {
        const getWebpageImage = async (guid) => {
            setInProgress(true);
            if (isValidGuid(guid) && !inProgress && !loaded) {
                const result = await SimpliCitySDK.webpage.getWebpageBannerImage(token, guid);
                const _image = result?.image;
                const _settings = result?.settings;
                setImage(_image);
                setSettings(_settings);
            }
            setInProgress(false);
            setLoaded(false);
        };
        getWebpageImage(webpage_guid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [webpage_guid]);

    return { image, settings, loaded };
};

export { useSimWebpageImage };
